import { IBookResultDetailInfo } from "@/repositories/book/parsers/bookResultInfoParser";
import { IBookResultInfo, IBookResultLineInfo } from "./book.types";

export class BookResultInfo implements IBookResultInfo {
  readonly id: string;
  readonly bookAmount: number;
  readonly bookIntervalCode: string;
  readonly bookDateTime: string;
  readonly bookCancelEndDateTime: string;
  readonly lineInfo: IBookResultLineInfo;
  readonly boardingDates?: IBookResultDetailInfo[];

  constructor(data: IBookResultInfo) {
    this.id = data.id;
    this.bookAmount = data.bookAmount;
    this.bookIntervalCode = data.bookIntervalCode;
    this.bookDateTime = data.bookDateTime;
    this.bookCancelEndDateTime = data.bookCancelEndDateTime;
    this.lineInfo = data.lineInfo;
    this.boardingDates = data.boardingDates;
  }
}
